export default "__VITE_ASSET__Dt_R8BaK__"